<template>

  <label
    v-if="type === 'label'"
    class="form-label"
  >
    <slot/>
  </label>

  <p
    v-else
    class="form-label"
  >
    <slot/>
  </p>

</template>

<script>
export default {
  name: 'CFormLabel',

  props: {
    type: {
      type: String,
      default: 'label',
      validator (value) {
        return [
          'label',
          'p'
        ].indexOf(value) >= 0
      }
    }
  }
}
</script>

<style scoped>
.form-label {
  display: inline;
  margin: 0;
}
</style>
